<script>
  import { acceptedCookies } from "../stores.js";
  import { fade } from "svelte/transition";

</script>

<div class="bg" transition:fade={{ duration: 125 }}>
  <div class="container">
    <div class="top">
      <img src="images/cookie.svg" alt="cookie icon" class="cookie" />
      <span>אפליקציית פיקאפ עושה שימוש בקבצי עוגיות (יאמי!)</span>
    </div>

    <div
      class="accept"
      on:click={() => {
        $acceptedCookies = true;
        localStorage.setItem('acceptedCookies', true);
      }}
    >
      אישור
    </div>
  </div>
</div>

<style>
  a {
    margin-top: 10px;
    display: inline-block;
    font-size: 1.5rem;
  }
  .bg {
    display: flex;
    width: 100%;
    height: 100%;
    background: #0008;
    padding: 20px;
    position: absolute;
    right: 0px;
    bottom: 0px;
    direction: rtl;
    font-size: 1.7rem;
    box-sizing: border-box;
    z-index: 9999;
  }

  .container {
    margin-top: auto;
    left: 20px;
    width: 100%;
    max-width: 260px;
    margin-left: auto;
    background: var(--blue1);
    color: white;
    box-shadow: 0 20px 20px -25px black;
    border-radius: 5px;
    padding: 10px;
    box-sizing: border-box;
  }

  .top {
    display: flex;
    align-items: center;
  }

  .cookie {
    width: 60px;
    height: 60px;
    padding: 10px;
    box-sizing: border-box;
  }

  .accept {
    width: 100%;
    background: white;
    color: var(--grey1);
    text-align: center;
    padding: 10px;
    box-sizing: border-box;
    margin-top: 10px;
    border-radius: 4px;
    cursor: pointer;
  }

</style>
